/* Drop-in replacements for the stock icons Curation used (react-icons' Material and Font Awesome sets), drawn as
   ONAM glyphs (mark.tsx). Each file swaps only where it imports from: "react-icons/md" becomes "onam/icons", the
   names stay. With FEATURES.curationSkin off, every name gives back the original icon. Same props as react-icons
   (size defaults to 1em, color, className, style, title, onClick). */

import React from "react";
import {
  MdDescription as _MdDescription,
  MdFingerprint as _MdFingerprint,
  MdSync as _MdSync,
  MdCheckCircle as _MdCheckCircle,
  MdCalendarToday as _MdCalendarToday,
  MdCode as _MdCode,
  MdGroups as _MdGroups,
  MdGroup as _MdGroup,
  MdRefresh as _MdRefresh,
  MdDns as _MdDns,
  MdCloud as _MdCloud,
  MdManageSearch as _MdManageSearch,
  MdMemory as _MdMemory,
  MdStorage as _MdStorage,
  MdViewStream as _MdViewStream,
  MdPublic as _MdPublic,
  MdKey as _MdKey,
  MdPerson as _MdPerson,
  MdBusiness as _MdBusiness,
  MdFlashOn as _MdFlashOn,
  MdNumbers as _MdNumbers,
  MdInfoOutline as _MdInfoOutline,
  MdPlayArrow as _MdPlayArrow,
  MdBarChart as _MdBarChart,
  MdSpeed as _MdSpeed,
  MdCampaign as _MdCampaign,
  MdLayers as _MdLayers,
  MdTrackChanges as _MdTrackChanges,
  MdCleaningServices as _MdCleaningServices,
  MdTag as _MdTag,
  MdCircle as _MdCircle,
  MdHub as _MdHub,
  MdSearch as _MdSearch,
  MdViewColumn as _MdViewColumn,
  MdError as _MdError,
  MdWarning as _MdWarning,
  MdTextFields as _MdTextFields,
  MdDataObject as _MdDataObject,
  MdOutlineAutorenew as _MdOutlineAutorenew,
  MdTravelExplore as _MdTravelExplore,
  MdTimeline as _MdTimeline,
  MdHistory as _MdHistory,
  MdCable as _MdCable,
  MdDashboard as _MdDashboard,
  MdMonitor as _MdMonitor,
} from "react-icons/md";
import { FaArrowUp as _FaArrowUp, FaPen as _FaPen, FaRedo as _FaRedo, FaHistory as _FaHistory, FaArrowRight as _FaArrowRight, FaInfo as _FaInfo, FaSearch as _FaSearch } from "react-icons/fa";
import { OI } from "./mark";
import { FEATURES } from "./features";

type P = { size?: number | string; color?: string; className?: string; style?: React.CSSProperties; title?: string; onClick?: (e: any) => void; [k: string]: any };
const make = (n: string, Orig: React.ComponentType<any>) => {
  const C = ({ size = "1em", ...p }: P) => (FEATURES.curationSkin ? <OI n={n} size={size} {...p} /> : <Orig size={size} {...p} />);
  return C;
};

export const MdDescription = make("notes", _MdDescription);
export const MdFingerprint = make("id", _MdFingerprint);
export const MdSync = make("refresh", _MdSync);
export const MdCheckCircle = make("done", _MdCheckCircle);
export const MdCalendarToday = make("calendar", _MdCalendarToday);
export const MdCode = make("code", _MdCode);
export const MdGroups = make("users", _MdGroups);
export const MdGroup = make("users", _MdGroup);
export const MdRefresh = make("refresh", _MdRefresh);
export const MdDns = make("server", _MdDns);
export const MdCloud = make("cloud", _MdCloud);
export const MdManageSearch = make("search", _MdManageSearch);
export const MdMemory = make("chip", _MdMemory);
export const MdStorage = make("layers", _MdStorage);
export const MdViewStream = make("stream", _MdViewStream);
export const MdPublic = make("globe", _MdPublic);
export const MdKey = make("key", _MdKey);
export const MdPerson = make("user", _MdPerson);
export const MdBusiness = make("building", _MdBusiness);
export const MdFlashOn = make("bolt", _MdFlashOn);
export const MdNumbers = make("hash", _MdNumbers);
export const MdInfoOutline = make("info", _MdInfoOutline);
export const MdPlayArrow = make("play", _MdPlayArrow);
export const MdBarChart = make("chart", _MdBarChart);
export const MdSpeed = make("gauge", _MdSpeed);
export const MdCampaign = make("megaphone", _MdCampaign);
export const MdLayers = make("layers", _MdLayers);
export const MdTrackChanges = make("target", _MdTrackChanges);
export const MdCleaningServices = make("eraser", _MdCleaningServices);
export const MdTag = make("hash", _MdTag);
export const MdCircle = make("dot", _MdCircle);
export const MdHub = make("hub", _MdHub);
export const MdSearch = make("search", _MdSearch);
export const MdViewColumn = make("columns", _MdViewColumn);
export const MdError = make("error", _MdError);
export const MdWarning = make("warn", _MdWarning);
export const MdTextFields = make("text", _MdTextFields);
export const MdDataObject = make("code", _MdDataObject);
export const MdOutlineAutorenew = make("refresh", _MdOutlineAutorenew);
export const MdTravelExplore = make("orbit", _MdTravelExplore);
export const MdTimeline = make("trail", _MdTimeline);
export const MdHistory = make("clock", _MdHistory);
export const MdCable = make("external", _MdCable);
export const MdDashboard = make("grid", _MdDashboard);
export const MdMonitor = make("activity", _MdMonitor);
export const FaArrowUp = make("arrowUp", _FaArrowUp);
export const FaPen = make("pen", _FaPen);
export const FaRedo = make("refresh", _FaRedo);
export const FaHistory = make("history", _FaHistory);
export const FaArrowRight = make("arrow", _FaArrowRight);
export const FaInfo = make("info", _FaInfo);
export const FaSearch = make("search", _FaSearch);
